// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-57ea8634] .form-control[readonly]:not([disabled]) {\n  background-color: white;\n}\n[data-v-57ea8634] textarea {\n  resize: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
